import { Grid } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";

const InputUrl = ({ label, value, onChange, disabled, error, InputProps = {}, ...rest }) => {
	return (
		<Grid
			size={{ md: 12 }}
			sx={{
				flexBasis: "100%",
				minWidth: "100%"
			}}
		>
			<MDBox>
				<MDInput
					disabled={disabled}
					error={error}
					className="dialogInput"
					label={label}
					value={value || ""}
					onChange={e => onChange(e.target.value)}
					type="url"
					{...InputProps}
					{...rest}
				/>
			</MDBox>
		</Grid>
	);
};

export default InputUrl;
